import { updateCurrentSetIndexWorkoutExerciseAction } from '@gymaholic/packages'
import { View } from 'components/View'
import openModalAction from 'modules/modal/actions/open'
import { MODAL_ID } from 'modules/modal/constants/index.cjs'
import { WORKOUT_SET_DATA_MODAL_TYPES } from 'modules/workout/redux/constants'
import SetRow from 'pages/Creator/SetRow'
import React from 'react'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'

/**
 * @param props
 * @param props.setData
 * @param props.currentWorkoutExercise
 * @return {Element}
 * @constructor
 */
export default function ExerciseSetData (props) {
  const {
    setData,
    currentWorkoutExercise
  } = props
  const dispatch = useDispatch()

  const handleClickSetValue = (set, setIndex) => {
    dispatch(
      updateCurrentSetIndexWorkoutExerciseAction(setIndex)
    )
    dispatch(
      openModalAction(MODAL_ID.WORKOUT_SET_INFO, {
        modalType: WORKOUT_SET_DATA_MODAL_TYPES.SET_VALUE,
        setData: set
      })
    )
  }

  const handleClickSetType = (set, setIndex) => {
    dispatch(
      updateCurrentSetIndexWorkoutExerciseAction(setIndex)
    )
    dispatch(
      openModalAction(MODAL_ID.WORKOUT_SET_INFO, {
        modalType: WORKOUT_SET_DATA_MODAL_TYPES.SET_TYPE,
        setData: set
      })
    )
  }

  const handleClickWeight = (set, setIndex) => {
    dispatch(
      updateCurrentSetIndexWorkoutExerciseAction(setIndex)
    )
    dispatch(
      openModalAction(MODAL_ID.WORKOUT_SET_INFO, {
        modalType: WORKOUT_SET_DATA_MODAL_TYPES.SET_WEIGHT,
        setData: set
      })
    )
  }

  return (
    <View mt={2}>
      {
        setData.map((set, index) => (
          <SetRow
            key={index}
            workoutExerciseObj={currentWorkoutExercise}
            setData={set}
            isSelected
            hideImage
            setIndex={index}
            handleClickSetValue={() => handleClickSetValue(set, index)}
            handleClickSetType={() => handleClickSetType(set, index)}
            handleClickWeight={() => handleClickWeight(set, index)}
          />
        ))
      }
    </View>
  )
}
